<alliance-carousel *ngIf="state.carouselOptions as carouselOptions" [options]="carouselOptions" class="santa-mt-10">
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.kanban">
    <p class="santa-typo-regular">{{ translations.content.organizeWork | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.setupRecruitment">
    <p class="santa-typo-regular">{{ translations.content.setupProject | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.recruitmentTemplates">
    <p class="santa-typo-regular">{{ translations.content.createRecruitmentTemplates | translate }}</p>
  </lib-slide-template>
  <lib-slide-template [categoryData]="CategoriesDataValuesEnum.publishVacancies">
    <p class="santa-typo-regular">{{ translations.content.publishVacancies | translate }}</p>
  </lib-slide-template>
</alliance-carousel>
